/** A textarea that grows with its text from `minRows` to `maxRows` lines (then scrolls); still resizable by hand. */
import { useLayoutEffect, useRef, type TextareaHTMLAttributes } from 'react';

export function AutoGrowTextarea({ minRows = 5, maxRows = 15, value, className, ...rest }: TextareaHTMLAttributes<HTMLTextAreaElement> & {
  value: string; minRows?: number; maxRows?: number;
}) {
  const ref = useRef<HTMLTextAreaElement>(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const cs = getComputedStyle(el);
    const line = parseFloat(cs.lineHeight) || parseFloat(cs.fontSize) * 1.5;
    const edges = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom) + parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);
    el.style.height = 'auto';
    const fit = el.scrollHeight + parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);
    el.style.height = `${Math.min(Math.max(fit, minRows * line + edges), maxRows * line + edges)}px`;
  }, [value, minRows, maxRows]);
  return <textarea ref={ref} rows={minRows} value={value} className={`textarea ${className ?? ''}`.trim()} {...rest} />;
}
